import { motion } from "framer-motion";

const CreativitySection = () => {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=800&h=900&fit=crop"
                alt="KAMAUU"
                className="w-full h-[500px] lg:h-[600px] object-cover"
              />
              
              {/* Quote Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
              
              <div className="absolute bottom-10 left-10 right-10 text-white">
                <p className="text-xl lg:text-2xl font-medium mb-4 leading-relaxed">
                  "Patreon provides a space for artists to sustain ourselves by
                  connecting us directly to our own communities."
                </p>
                <p className="text-lg font-bold">KAMAUU</p>
              </div>
            </div>

            {/* Decorative Small Images */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="absolute -right-6 top-10 w-32 h-32 rounded-2xl overflow-hidden shadow-lg hidden lg:block"
            >
              <img
                src="https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=200&h=200&fit=crop"
                alt="Creator 2"
                className="w-full h-full object-cover"
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="absolute -left-6 bottom-10 w-28 h-28 rounded-2xl overflow-hidden shadow-lg hidden lg:block"
            >
              <img
                src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&h=200&fit=crop"
                alt="Creator 3"
                className="w-full h-full object-cover"
              />
            </motion.div>
          </motion.div>

          {/* Right - Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-8"
          >
            <h2 className="text-5xl lg:text-6xl font-bold leading-tight text-gray-900">
              Creativity powered by fandom
            </h2>

            <p className="text-xl text-gray-700 leading-relaxed">
              Patreon is the best place to build community with your biggest fans, share exclusive work, and turn your passion into a lasting creative business.
            </p>

            <div className="pt-4">
              <a
                href="#creators"
                className="inline-flex items-center text-lg font-semibold hover:underline"
                style={{ color: 'var(--patreon-btn-primary-bg)' }}
              >
                Meet our creators
                <svg
                  className="ml-2 w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CreativitySection;
